import {
  PeriodonticsEnum,
  RootPlaningAndSubgingivalCurettageEnum
} from "requests";

export const ROOT_PLANING_SUBGINGIVAL_CURETTAGE_OPTIONS = [
  { value: RootPlaningAndSubgingivalCurettageEnum.Open, label: "Open" },
  { value: RootPlaningAndSubgingivalCurettageEnum.Closed, label: "Closed" }
];

export const PERIODONTICS_OPTIONS = [
  {
    value: PeriodonticsEnum.UltrasonicScalingAndPolishing,
    label: "Ultrasonic Scaling and Polishing"
  },
  {
    value: PeriodonticsEnum.RootPlaningAndSubgingivalCurettage,
    label: "Root Planing & Subgingival Curettage",
    selectOptions: ROOT_PLANING_SUBGINGIVAL_CURETTAGE_OPTIONS
  },
  {
    value: PeriodonticsEnum.GingivectomyGingivoplasty,
    label: "Gingivectomy/Gingivoplasty"
  }
];
